
    
export default {

        mixins:[],
        props: [
            'type',
            'loading',
            'colour',
            'size',
            'text',
            'disabled',
            'icon',
            'align'
        ],
        
        data : function(){       
            return {

               

            };
        },
        computed: {

            getClass(){

                let classList = '';
                classList += this.loading ? ' is-loading ' : '';
                classList += this.colour ? ' '+this.colour+' ' : '';
                classList += this.icon ? ' icon '+this.icon+' ' : '';
                classList += this.size ? ' '+this.size+' ' : '';
                classList += this.align ? ' '+this.align+' ' : '';
                return classList;
          
            }

            
        
        },
        watch :{

            

        },
        created : function(){
        },
        mounted : function ()
        {

        },
        destroyed () {
        },
        methods:{



        }
    }
